
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tableHeader'
})

export class TableHeaderPipe implements PipeTransform {

  constructor(
  ) {

  }

  transform(data: any, url?: string): string[] {

    var headers = Object.keys(data[0]);

    if (url==null) {
      return headers;
    }
    
    var translateHeaders: string[] = [];

    for (let index = 0; index < headers.length; index++) {
      const element: string = headers[index];
      translateHeaders.push(`${url}.${element.toLowerCase()}`);
    }

    return translateHeaders;
  }

}